if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('slide-cart') || document.querySelector('cart-notification') || document.querySelector('cart-drawer') || document.querySelector('cart-popup');
        this.submitButton = this.querySelector('[type="submit"]');
        this.preventNotification = this.form.dataset.preventNotification;
        this.modal = this.closest('modal-component');

        if (document.querySelector('slide-cart') || document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          this.cart.preventNotification = this.preventNotification;

          formData.append(
            'sections',
            this.cart
              .getSectionsToRender()
              .map((section) => section.section || section.id)
              .join(',')
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            const afterRender = () => {
              if (!this.error) {
                this.publishCartUpdate(formData);
              }
            };

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    Promise.resolve(this.cart.renderContents(response)).finally(afterRender);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              Promise.resolve(this.cart.renderContents(response)).finally(afterRender);
            }
            const cartContainer = this.closest('cart-notification') || this.closest('slide-cart');
            const upsellSlider = this.closest('cart-upsells-slider');
            if (cartContainer && upsellSlider) {
              const gtmEvent = 'upsell_add_to_cart';
              if (typeof window.pushToDataLayer === 'function') {
                window.pushToDataLayer({ event: gtmEvent, productVariantId: formData.get('id') });
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
              if (this.modal) {
                this.modal.close(this.modal.id);
              }
            }
          });
      }

      publishCartUpdate(formData) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          preventNotification: this.preventNotification,
        });
        this.dispatchEvent(new CustomEvent('product-added', { detail: { productVariantId: formData.get('id') } }));
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.dispatchEvent(new CustomEvent('product-error', { detail: { errorMessage } }));
        }
      }
    }
  );
}
